module.exports = __webpack_public_path__ + "static/text1-349383e3f4c4144289fc21e454689fb0.svg";